"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadedFilesReducerBase = void 0;
var actions_1 = require("../../constants/actions");
var createGenericReducer_1 = require("./createGenericReducer");
exports.uploadedFilesReducerBase = (0, createGenericReducer_1.createGenericReducer)({
    getSuccessAction: actions_1.GET_UPLOADED_FILES_SUCCESS,
    deleteRequestAction: actions_1.DELETE_UPLOADED_FILES_REQUEST,
    deleteSuccessAction: actions_1.DELETE_UPLOADED_FILES_SUCCESS,
    clearActions: [actions_1.CLEAR_WORKSPACE_SCOPE],
    // debug: true,
});
